import React from 'react'; 
import Image from "../../elements/Image"; 
import TheTrihurstContent from "./TheTrihurstContent";
import { classNames } from "../../../helpers/classNames";


const TheTrihurst = ({ data }) => {
  const TheTrihurstContentDertails = {
    SubTitle: "Built on Values",
    title: "Trhurst Tech’s Belief System",
    description: "At Trhurst Tech, our belief system is the foundation of every decision we make. We’re guided by principles that prioritize ethical innovation, transparency, and impact—ensuring our technology creates real value for people, businesses, and the future of finance.",
  }
  return (
    <>
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4 pt-28">
        <div className="relative flex items-start gap-60"> 
          <TheTrihurstContent data={TheTrihurstContentDertails} />
          <div className="relative h-full w-2/5 z-10">
            <div className="relative z-10 bg-primary bg-opacity-10 border border-primaryBorder rounded-3xl py-10 px-9 backdrop-blur-lg">
              <h4 className="uppercase text-white text-xl leading-7 mb-4">{data.title}</h4>
              <div className="relative flex flex-col space-y-7 "> 
                {data.items.map((item, index) => (
                  <div key={index} className="relative flex items-center">
                    <div className="relative flex items-center space-x-5">
                      <div className={classNames("!w-10 !h-10 !rounded-full overflow-hidden p-2",item.bgClass)}>
                        <Image
                          src={item.image}
                          width="100%"
                          height="100%"
                          alt={item.title}
                          classes="object-cover "
                        />
                      </div>
                      <div className="text-white">
                        <h4 className="text-base">{item.title}</h4>
                        <div className="text-shades-01 uppercase text-xs">{item.sub}</div>
                      </div>
                    </div>

                    <div className="relative text-primaryBorder flex items-center ml-auto space-x-5 text-lg">
                      <div className="relative">{item.value}</div>
                      <div className="relative">
                        <i className={item.icon}></i>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="absolute top-0 left-0 h-full w-full flex justify-between z-0">
              <div className="absolute -top-2 -right-4 border-[35px] rounded-full border-[#043C29] b max-w-full w-[288px] h-[288px]"></div>
              <div className="absolute -bottom-16 -left-28 border-[35px] rounded-full border-[#043C29] b max-w-full w-[389px] h-[389px]"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TheTrihurst;;